import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -25px;
  padding: 20px 14px;
  background-color: ${(p) => p.theme.colors.black};
`;
